module.exports = __webpack_public_path__ + "static/media/barbearia.abd94648.jpg";